import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  withCredentials: true,
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest?.url?.includes('/Login/Logout')
    ) {
      window.location.href = '/login';
    }

    return Promise.reject(error);
  },
);

export default instance;
